export default "/react/logoDyCont-10798c4c.png";